
import React, { useEffect } from 'react';
import '../style/App.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart, faComment } from '@fortawesome/free-regular-svg-icons';
import { faHeart as faHeartSolid, faTrash } from '@fortawesome/free-solid-svg-icons';
import { useAuth0 } from '@auth0/auth0-react';
import { useTwitterContext } from '../TwitterContext';
import UserInfo from './UserInfo';
import Translate from './Translate';
import { useNavigate } from 'react-router-dom';

const Tweet = ({ tweet, user, onDelete }) => {
  const [isLiked, setIsLiked] = React.useState(false);
  const { loginWithRedirect } = useAuth0();
  const { accessToken, curUser } = useTwitterContext();
  const [likedId, setLikedId] = React.useState(null);
  const [curTweet, setCurTweet] = React.useState(tweet);
  const [isEditing, setIsEditing] = React.useState(false);
  const [isDeleted, setIsDeleted] = React.useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (curUser === null) {
      setIsLiked(false);
      setLikedId(null);
      return;
    }
    for (let i = 0; i < curTweet.likes.length; i++) {
      if (curTweet.likes[i].userId === curUser.id) {
        setIsLiked(true);
        setLikedId(curTweet.likes[i].id);
        return;
      }
    }
    setIsLiked(false);
    setLikedId(null);
  }, [curUser, curTweet]);

  const HandleLikeClick = async () => {
    try {
      if (curUser === null) {
        loginWithRedirect();
        return;
      } else if (isLiked && likedId !== null) {
        // Unlike the tweet
        const data = await fetch(`${process.env.REACT_APP_API_URL}/likes/${likedId}`, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`,
          },
        });
        const result = await data.json();
        let newTweet = curTweet;
        newTweet.likes = newTweet.likes.filter((like) => like.id !== result.id);
        setCurTweet(newTweet);
      } else {
        // Like the tweet
        const data = await fetch(`${process.env.REACT_APP_API_URL}/likes`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`,
          },
          body: JSON.stringify({
            userId: curUser.id,
            tweetId: curTweet.id,
          }),
        });
        // refresh this component
        const result = await data.json();
        let newTweet = curTweet;
        newTweet.likes = [...newTweet.likes, result];
        setCurTweet(newTweet);
      }
      for (let i = 0; i < curTweet.likes.length; i++) {
        if (curTweet.likes[i].userId === curUser.id) {
          setIsLiked(true);
          setLikedId(curTweet.likes[i].id);
          return;
        }
      }
      setIsLiked(false);
      setLikedId(null);
    } catch (error) {
      console.error('Error handling like:', error);
      // Handle error as needed
    }
  };

  async function JumpToDetail() {
    if (isEditing) {
      return;
    }
    navigate(`/details/${tweet.id}`);
  }

  async function DeleteTweet() {
    await fetch(`${process.env.REACT_APP_API_URL}/tweets/${tweet.id}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`,
      },
    });
    setIsDeleted(true);
    if (onDelete) {
      onDelete();
    }
  }

  function SwitchEditPanel() {
    setIsEditing(!isEditing);
    let text = document.getElementById("tweet-content-text");
    if (text.contentEditable === "true") {
      text.contentEditable = false;
      text.style.border = "none";
      let button = document.getElementsByClassName("edit-button")[0];
      button.remove();
      return;
    }
    text.contentEditable = true;
    text.focus();
    text.style.border = "1px solid #ccc";
    let content = document.getElementsByClassName("tweet-content")[0];
    let button = document.createElement("button");
    button.innerHTML = "Save";
    button.onclick = EditTweet;
    button.className = "edit-button";
    content.appendChild(button);
  }

  async function EditTweet() {
    const updatedText = document.getElementById("tweet-content-text").innerText;
    await fetch(`${process.env.REACT_APP_API_URL}/tweets/${tweet.id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`,
      },
      body: JSON.stringify({
        text: updatedText,
      }),
    });
  }

  if (isDeleted) {
    return null;
  }
  return (
    <div className="tweet" loading="lazy">
      <UserInfo info={user}/>
      <div className="tweet-content">
        <p onClick={JumpToDetail} id="tweet-content-text">{curTweet.text}</p>
        <Translate text={curTweet.text} />
        {curTweet.img && <img src={curTweet.img} className="tweet-image" alt="tweet-img" onClick={JumpToDetail} loading="lazy"/>}
      </div>
      <div className="tweet-buttom">
        <FontAwesomeIcon
        icon={isLiked ? faHeartSolid : faHeart}
        className="tweet-buttom-img"
        alt="like"
        onClick={() => HandleLikeClick(curTweet.id, curUser.id, likedId, isLiked, accessToken)}
        />
        <p className="tweet-buttom-detail">{curTweet.likes.length} likes </p>
        <FontAwesomeIcon icon={faComment} className="tweet-buttom-img" onClick={JumpToDetail}/>
        <p className="tweet-buttom-detail" onClick={JumpToDetail}>
          {curTweet.comments.length} comments 
        </p>
        {/* {curUser && curUser.id === user.id && 
        <FontAwesomeIcon className="tweet-buttom-detail" icon={faPenToSquare} onClick={SwitchEditPanel} />} */}
        {curUser && curUser.id === user.id && 
        <FontAwesomeIcon className="tweet-buttom-detail" icon={faTrash} onClick={DeleteTweet} />}
      </div>
    </div>
  );
};

export default Tweet;